module.exports = __webpack_public_path__ + "assets/img/jindu_2.91a8a939.png";